import React from "react";

import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import banner from "../assets/imagen.jpg";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import "../components/boletines.css"
import SocialBar from "../components/SocialBar";
const Boletines = () => {
  return (
    <Container fluid className="p-0">
        <NavbarFacach/>
        <Image src={banner} alt="banner" fluid></Image>
      <Row className="text-center mb-4">
        <Col>
          <h2 className="titulo">BOLETÍNES</h2>
          <p className="descripcion">
            En esta sección 
          </p>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col md={5} className="mb-4">
          <Card className="plan-card">
            <Card.Body>
              <Card.Title>
                Ejemplo 1 
              </Card.Title>
              <Card.Text>
                Descargar
              </Card.Text>
             <div className="boton-centro">
                <a
                href="https://facach.coop.hn/_files/ugd/3a8449_5e1f5ddc28f84729b2a16a9ab298dfc5.pdf"
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver documento
              </a>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={5} className="mb-4">
          <Card className="plan-card">
            <Card.Body>
              <Card.Title>Ejemplo 2</Card.Title>
              <Card.Text>
                Descargar
              </Card.Text>
              <div className="boton-centro">
                <a
                href="https://facach.coop.hn/_files/ugd/3a8449_5e1f5ddc28f84729b2a16a9ab298dfc5.pdff"
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver documento
              </a>
              </div>
              
            </Card.Body>
          </Card>
        </Col>
        <Col md={5} className="mb-4">
          <Card className="plan-card">
            <Card.Body>
              <Card.Title>Ejemplo 3</Card.Title>
              <Card.Text>
                ssss
              </Card.Text>
              <div className="boton-centro">
                <a
                href="https://facach.coop.hn/_files/ugd/3a8449_5e1f5ddc28f84729b2a16a9ab298dfc5.pdff"
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver documento
              </a>
              </div>
              
            </Card.Body>
          </Card>
        </Col>
        <Col md={5} className="mb-4">
          <Card className="plan-card">
            <Card.Body>
              <Card.Title>Ejemplo 4</Card.Title>
              <Card.Text>
                Accede al plan a
              </Card.Text>
              <div className="boton-centro">
                <a
                href="https://facach.coop.hn/_files/ugd/3a8449_5e1f5ddc28f84729b2a16a9ab298dfc5.pdff"
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver documento
              </a>
              </div>
              
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <SocialBar
          position="right" 
          top="35%" 
          size={42} 
          rounded={true} 
        />
 
      <FooterFacach/>
    </Container>
  );
};

export default Boletines;
